import { Typography } from '@bowtie-ins/bowkit';
import { HOTEL_CALIFORNIA } from '@bowtie-ins/bowkit/palette';
import Box from '@material-ui/core/Box';
import { FormattedMessage } from 'react-intl';
import { QuotationContextValue } from '../contexts/QuotationContext';

type Props = Pick<QuotationContextValue, 'isIssueAgeValid'> & {
  formValues: QuotationContextValue['values'];
};

const ErrorMessagePanel = ({ formValues, isIssueAgeValid }: Props) => {
  return !isIssueAgeValid ? (
    <Box display="flex" justifyContent="center" color={HOTEL_CALIFORNIA}>
      <Typography>
        <FormattedMessage id="invalid-age" values={formValues} />
      </Typography>
    </Box>
  ) : null;
};

export default ErrorMessagePanel;
